import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { IconButton, Tooltip as MuiTooltip } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    helpIcon: {
        color: '#4a4a4a',
        fontSize: '1.6rem',
        '&:hover': {
            color: '#3273dc',
        },
    },
    tooltip: {
        fontSize: '1.4rem',
        maxWidth: '300px',
        padding: theme.spacing(1.5),
        lineHeight: 1.4,
    },
}));

const Tooltip = ({ text, children, className, iconClass }) => {
    const classes = useStyles();

    // Use children if provided, otherwise use text prop
    const tooltipContent = children || text;

    return (
        <MuiTooltip
            title={tooltipContent}
            arrow
            classes={{
                tooltip: classes.tooltip
            }}
        >
            <IconButton size="small" className={className}>
                <HelpOutlineIcon className={classes.helpIcon} />
            </IconButton>
        </MuiTooltip>
    );
};

export default Tooltip;
